export const SCROLL_CONFIG = {
  wheelMultiplier: 1.5,
  parallaxDepth: 15,
  revealThreshold: 0.15,
  revealMargin: "0px 0px -40px 0px",
} as const;

export const SECTIONS = [
  { id: "home", label: "Home" },
  { id: "mission", label: "Our Mission" },
  { id: "educators", label: "For Educators" },
  { id: "learners", label: "For Learners" },
  { id: "community", label: "Community" },
  { id: "about", label: "About Us" },
] as const;

export type SectionId = (typeof SECTIONS)[number]["id"];
